import firebase from "firebase";


// const firebaseConfig = {
//     apiKey: process.env.FIREBASE_API_KEY,
//     authDomain: "chat-app-648b9.firebaseapp.com",
//     projectId: "chat-app-648b9",
//     storageBucket: "chat-app-648b9.appspot.com",
//     messagingSenderId: "317851240307",
//     appId: process.env.FIREBASE_APP_ID,
//     measurementId: "G-1HEVQENKGH"
// };

const firebaseConfig = {
    apiKey: "AIzaSyDudR0iHZg3uEIN6VNcKQHFNIIqWizfO9o",
    authDomain: "chat-app-648b9.firebaseapp.com",
    projectId: "chat-app-648b9",
    storageBucket: "chat-app-648b9.appspot.com",
    messagingSenderId: "317851240307",
    appId: "1:317851240307:web:78c94eb4ee41162de72706",
    measurementId: "G-1HEVQENKGH"
};



const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();


export default db;